/* eslint-disable react/button-has-type */
import React, { useEffect, useRef, useState } from 'react';
import './view.scss';
import { faEnvelope, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp, faFacebookMessenger } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { setHideContactWidget, selectShowContactWidget } from 'utilities/redux/contactWidgetSlice';
import { useAppDispatch, useAppSelector } from 'utilities/redux/reduxHooks';

export const ContactWidget = () => {
    const [expanded, setExpanded] = useState(false);
    const handleToggle = () => setExpanded((prev) => !prev);
    const fabRef = useRef(null);
    const showContactWidget = useAppSelector(selectShowContactWidget);
    const dispatch = useAppDispatch();

    const hideWidget = (payload = undefined) => {
        dispatch(setHideContactWidget(payload));
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (fabRef.current && !fabRef.current.contains(event.target)) {
                setExpanded(false);
            }
        };

        if (expanded) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [expanded]);

    if (showContactWidget === false) {
        return null;
    }
    return (
        <div className="fabContainer" onMouseLeave={ handleToggle } ref={ fabRef }>
            {expanded && (
                <div className="options">
                    <a
                        href="https://wa.me/+48880137932"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="fabButton"
                    >
                        <FontAwesomeIcon icon={ faWhatsapp } />
                    </a>
                    <a
                        href="https://m.me/baranskidrzwi"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="fabButton"
                    >
                        <FontAwesomeIcon icon={ faFacebookMessenger } />
                    </a>
                </div>
            )}
            <button className={ `${'fabMain'} ${expanded ? 'close' : ''}` } onClick={ expanded ? () => hideWidget() : () => setExpanded(true) }>
                <FontAwesomeIcon icon={ expanded ? faTimes : faEnvelope } />
                {expanded && <span className="tooltip">Ukryj</span>}
            </button>
        </div>
    );
};
